import * as fs from 'file-saver';
import { Workbook } from 'exceljs';

export async function exportDataTableExcel(
  headerTable: any[] | any,
  bodyTable: any,
  CONF: any,
  fileName: any
) {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(fileName);

  //Add Header Row
  const headerRow = worksheet.addRow(headerTable);

  // Cell Style : Fill and Border
  headerRow.eachCell((cell: any) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'fffdfa' },
      bgColor: { argb: 'fffdfa' },
    };
    cell.border = {
      top: { style: 'thin', color: { argb: '9b9e9c' } },
      left: { style: 'thin', color: { argb: '9b9e9c' } },
      bottom: { style: 'thin', color: { argb: '9b9e9c' } },
      right: { style: 'thin', color: { argb: '9b9e9c' } },
    };
    cell.alignment = { vertical: 'center', horizontal: 'center' };
    cell.font = {
      color: { argb: '464646' },
      name: 'Arial',
      family: 4,
      size: 8,
      bold: true,
    };
    cell.width = 30;
  });

  worksheet.columns = CONF;
  // Add Data and Conditional Formatting
  bodyTable.forEach((d: any, number: any) => {
    const row = worksheet.addRow(d);
    for (let i = 1; i <= headerTable.length; i++) {
      const qty: any = row.getCell(i);
      qty.border = {
        top: { style: 'thin', color: { argb: '9b9e9c' } },
        left: { style: 'thin', color: { argb: '9b9e9c' } },
        bottom: { style: 'thin', color: { argb: '9b9e9c' } },
        right: { style: 'thin', color: { argb: '9b9e9c' } },
      };

      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' },
        bgColor: { argb: 'FFFFFF' },
      };
    }
  });

  workbook.xlsx
    .writeBuffer()
    .then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, fileName + '.xlsx');
    })
    .catch((error: any) => {});
}
